<template>
  <v-dialog
    v-model="dialog"
    persistent
    height="80vh"
    scrollable
    fullscreen
    @keydown="checkEsc"
  >
    <v-card>
      <v-card-title>
        <v-btn @click.native="dialog = false" icon large>
          <i class="v-icon material-icons">close</i>
        </v-btn>
        <span class="headline" v-text="$t('global.works')"></span>
        <v-spacer></v-spacer>
        <div class="input-holder d-flex search-holder">
          <v-text-field
            :label="globalTexts.search"
            v-model="search"
            @input="searchKeyPress"
          ></v-text-field>
        </div>
        <v-btn class="tree-button" @click="setFormState(true)" icon large>
          <i class="v-icon material-icons">account_tree</i>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-layout wrap>
          <Split class="split-holder" ref="split-holder">
            <SplitArea
              v-show="formState == 0 || formState == 1"
              :size="20"
              class="d-none- d-sm-block-"
            >
              <v-flex class="elevation-1 tree-holder">
                <b-tree-view
                  :data="treeData"
                  :contextMenuItems="[]"
                  ref="tree"
                  :nodesDraggable="false"
                  :renameNodeOnDblClick="true"
                  :showIcons="true"
                  @nodeSelect="nodeSelect"
                ></b-tree-view>
              </v-flex>
            </SplitArea>
            <SplitArea v-show="formState == 0 || formState == 2" :size="75">
              <v-flex class="items-holder ih-" ref="items-holder">
                <!--<div class="input-holder" ref="barcode">
                  <input-with-vk
                          :inputVal="search"
                          :label="'Поиск'"
                          @input="searchInput"
                          :appendIcon="'search'"
                  ></input-with-vk>
                </div>-->
                <div>
                  <h6 class="full-name-header">{{ parentFullName }}</h6>
                </div>
                <!--hide-actions-->
                <v-data-table
                  :items="items"
                  :headers="headers"
                  class="elevation-1 ih-table"
                  :rows-per-page-items="rowsPerPage"
                  ref="dataTable"
                  :search="search"
                >
                  <template slot="items" slot-scope="props">
                    <tr @click="selectItem(props.item)">
                      <td class="text-xs-left">{{ props.index + 1 }}</td>
                      <td class="text-xs-left">
                        <div>
                          <div>
                            ({{props.item.code}}) {{ props.item.name }}
                          </div>
                          <div>
                            <h6 class="full-name-holder">
                              {{ props.item.fullName }}
                            </h6>
                          </div>
                        </div>
                      </td>
                      <td class="text-xs-center">{{ props.item.unit }}</td>
                      <td class="text-xs-center">{{ props.item.baseTime }}</td>
                    </tr>
                  </template>
                  <template slot="no-data">
                    <div v-if="noItems">
                      <h3 class="text-center">
                        {{ $t('docList.noDocs') }}
                      </h3>
                    </div>
                    <div v-else>
                      <spinner></spinner>
                    </div>
                  </template>
                </v-data-table>
              </v-flex>
            </SplitArea>
          </Split>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { bTreeView } from 'bootstrap-vue-treeview'
import store from '@/services/store'
import _ from 'lodash'
import Vue from 'vue'
import VueSplit from 'vue-split-panel'
import i18n from '@/plugins/i18n'

Vue.use(VueSplit)

export default {
  name: 'ProductSelect',
  data: () => ({
    dialog: false,
    formState: 0,
    treeData: [{}],
    showTree: true,
    noItems: false,
    search: '',
    headers: [
      {
        colId: 'worksColumnIndex',
        text: '№',
        align: 'center',
        class: 'tab-col-tiny',
        value: 'index',
      },
      {
        colId: 'worksColumnProductCode',
        text: 'Код',
        value: 'code',
      },
      {
        colId: 'worksColumnProductName',
        text: 'Наименование',
        value: 'name',
      },
      {
        colId: 'worksColumnMeasureName',
        text: 'Ед.',
        align: 'center',
        value: 'unit',
      },
      {
        colId: 'worksColumnNorm',
        text: 'Норма',
        align: 'center',
        value: 'baseTime',
      },
    ],
    items: [{}],
    parentId: '',
    parentCode: '',
    parentFullName: '',
    tmpParentId: '',
    rowsPerPage: [100, 50, 20],
    selectedItem: null,
  }),
  components: {
    spinner: () => import('./Spinner.vue'),
    'b-tree-view': bTreeView,
    'input-with-vk': () => import('./InputWithVKeyboard.vue'),
  },
  created() {
    this.refreshListOptions()
  },
  computed: {
    globalTexts: function() {
      return i18n.messages[i18n.locale].global
    },
    docZNTexts: function() {
      return i18n.messages[i18n.locale].docZN
    },
  },
  watch: {
    parentId: function() {
      this.fetchData()
    },
  },

  methods: {
    refreshListOptions() {
      this.headers.forEach(element => {
        element.text = this.docZNTexts[element.colId]
      })
    },
    show() {
      this.$nextTick(() => {
        window.addEventListener('resize', this.setFormState)
        this.fetchData()
        this.fillTree()
        this.setFormState(false)
        this.dialog = true
      })
    },
    setFormState(changeShowTree) {
      var tmpFormState = 0

      if (changeShowTree === true) {
        this.showTree = !this.showTree
      }
      if (typeof window.innerWidth == 'number') {
        if (window.innerWidth <= 480) {
          if (this.showTree) {
            tmpFormState = 1
          } else {
            tmpFormState = 2
          }
        } else {
          tmpFormState = 0
        }
      } else {
        tmpFormState = 0
      }
      if (tmpFormState != this.formState) {
        this.formState = tmpFormState
      }
    },
    searchKeyPress() {
      if (this.search === '') {
        this.parentId = this.tmpParentId
      } else {
        this.parentId = ''
      }
      this.setFormState(false)
    },
    nodeSelect(node, isSelected) {
      if (isSelected) {
        this.parentCode = node.data.code
        this.parentId = node.data.id
        this.tmpParentId = node.data.id
        this.parentFullName = node.data.fullName
        this.setFormState(true)
      }
    },
    fetchData() {
      this.items = []
      this.noItems = false
      var goodsList = undefined
      goodsList = store.state.products.goodsList
      if (this.parentId) {
        if (store.state.showRecommendationsList) {
          this.items = _.filter(goodsList, item => {
            return (
              item.isRecommendation === '1' &&
              (item.parentCode === this.parentCode ||
                item.parentListCode.search(this.parentCode) != -1)
            )
          })
        } else {
          this.items = _.filter(goodsList, item => {
            return (
              item.parentCode === this.parentCode ||
              item.parentListCode.search(this.parentCode) != -1
            )
          })
        }
      } else {
        if (store.state.showRecommendationsList) {
          this.items = _.filter(goodsList, { isRecommendation: '1' })
        } else {
          this.items = goodsList
        }
      }
    },
    fillTree() {
      var treeSource = undefined
      if (
        store.state.showRecommendationsList &&
        store.state.products.recommendationParentsList
      ) {
        treeSource = store.state.products.recommendationParentsList
      } else {
        treeSource = store.state.products.parentsList
      }
      let sortedTree = {
        map: [],
        tree: [],
      }

      const addNewItem = (item, scope) => {
        let newItem = {
          id: item.id,
          parentId: item.parentId,
          fullName: item.fullName,
          code: item.code,
          name: item.name,
          children: [],
        }
        scope.push(newItem)
        sortedTree.map[item.id] = newItem
        return newItem
      }

      const addItem = item => {
        if (sortedTree.map[item.id]) return

        if (!item.parentId) {
          return addNewItem(item, sortedTree.tree)
        }
        //дерево предварительно отсортировано в 1с по иерархии
        //так что, родитель должен быть
        //уже помещен в массив map, если нет - ошибка, просто добавим в корень дерева
        let parentNode = sortedTree.map[item.parentId]

        if (!parentNode) {
          let parentItem = _.filter(treeSource, ['id', item.parentId])[0]
          if (!parentItem) {
            console.error('что-то не так, не нашли родителя')
          } else {
            parentNode = addNewItem(parentItem, sortedTree.tree)
          }
        }

        if (parentNode) {
          return addNewItem(item, parentNode.children)
        } else {
          return undefined
        }
      }

      if (treeSource) {
        treeSource.forEach(element => {
          if (!sortedTree.map[element.id]) {
            addItem(element)
          }
        })
      }
      this.treeData = sortedTree.tree
    },
    calcRowsPerPage() {
      let trow
      let trowH
      let that = this

      let waitForHeightAvailable = callback => {
        trow = $(' .ih-table tbody tr')
        trowH = trow.height()
        if (trow.length && trowH > 0) {
          callback()
        } else {
          setTimeout(function() {
            waitForHeightAvailable(callback)
          }, 100)
        }
      }

      waitForHeightAvailable(() => {
        let tholderH = $('.ih-table .v-table__overflow').height()
        let theadH = $('.ih-table thead').height()
        let rowsPerPage = Math.max(1, Math.round((tholderH - theadH) / trowH))
        let rowsPerPageText = [rowsPerPage, 5, 20]
        that.rowsPerPage = rowsPerPageText
        if (that.$refs.dataTable)
          that.$refs.dataTable.updatePagination({ rowsPerPage: rowsPerPage })
      })
    },
    selectItem(item) {
      this.selectedItem = item
      this.dialog = false
      this.$emit('prodItemSelected', item)
    },
    checkEsc(ev) {
      if (ev.keyCode === 27) this.dialog = false
    },
    searchInput(payload) {
      this.search = payload
    },
  },
}
</script>

<style scoped lang="scss">
@import '../_scss/main';
.v-dialog__content {
  /deep/ .v-dialog {
    @include xxs {
      margin: 3px;
      max-width: 100%;
    }
  }
}

.split-holder {
  height: auto;
  display: flex;
  height: 100%;
  .split {
    display: flex;
    padding: 5px;
    flex-grow: 1;
    height: auto;
  }
  /deep/ .gutter-horizontal {
    @include sm {
      display: none;
    }
  }
}

.tree-holder {
  height: auto;
  padding: 0 5px;
}
.tree-button {
  display: none;
  @include xxs {
    display: inline;
  }
}

.headline {
  @include xxs {
    display: none;
  }
}

.tree-view {
  /deep/ .tree-node-icon {
    color: #fff !important;
  }
  /deep/ .tree-branch.selected > .tree-node > .tree-node-label {
    background-color: #616161;
  }
  /deep/ .tree-node-label:hover {
    background-color: #616161;
  }
}

.v-card {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.v-card__title {
  padding-bottom: 0;
}

.v-card__text {
  flex-grow: 1;
  display: flex;
  padding-bottom: 0;
  height: 100%;
  > .container {
    display: flex;
    margin: 0 auto;
    padding-top: 0;
  }
}

.v-dialog__content {
  /deep/ .v-dialog {
    height: 100%;
  }
}

.items-holder {
  display: flex;
  flex-direction: column;
  padding-left: 5px;
  width: 100%;
}

.full-name-header {
  font-size: 1rem;
  margin: 5px 10px;
  line-height: 1;
  color: cadetblue;
}

.full-name-holder {
  font-size: 0.8rem;
  margin-bottom: 0;
  line-height: 1;
  color: cadetblue;
}

.ih-table {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: auto;

  /deep/ .v-table__overflow {
    flex-grow: 1;
  }
  /deep/ .v-table tr td {
    height: auto;
    padding: 10px;
  }
  /deep/ .tab-col-tiny {
    width: 20px;
    padding: 10px;
  }
  /deep/ .ih-row-actions {
    position: absolute;
    z-index: 10;
    display: none;
    right: 0;
  }
  /deep/ tbody tr {
    position: relative;
    &:hover .ih-row-actions {
      display: inline-block;
    }
  }
}
</style>
